import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SidebarGuard, SceneGuard } from '@guards';
import {
	IntroComponent,
	PortalComponent,
	StageComponent,
	SyncComponent,
	ContentComponent,
	FormComponent,
	SendComponent,
	TabComponent,
	PrivacyComponent,
	ImprintComponent
} from '@components';

const routes: Routes = [
	{
		path: 'portal',
		component: PortalComponent,
		children: [
			{
				path: 'stage',
				component: StageComponent,
				canActivate: [SceneGuard, SidebarGuard],
				data: {
					state: 'stage'
				}
			},
			{
				path: 'stage/:scene',
				component: StageComponent,
				canActivate: [SceneGuard, SidebarGuard],
				data: {
					state: 'stage'
				}
			},
			{
				path: 'content/:content',
				component: ContentComponent,
				canActivate: [SceneGuard, SidebarGuard],
				data: {
					state: 'content'
				},
				children: [
					{
						path: 'tab/:tab',
						component: TabComponent
					},
					{
						path: 'form',
						component: FormComponent
					}
				]
			},
			{
				path: 'privacy',
				component: PrivacyComponent,
				canActivate: [SceneGuard, SidebarGuard],
				data: {
					state: 'content'
				}
			},
			{
				path: 'imprint',
				component: ImprintComponent,
				canActivate: [SceneGuard, SidebarGuard],
				data: {
					state: 'content'
				}
			}
		]
	},
	{
		path: 'intro',
		component: IntroComponent
	},
	{
		path: 'sync',
		component: SyncComponent
	},
	{
		path: 'send',
		component: SendComponent
	},
	{
		path: '',
		pathMatch: 'full',
		redirectTo: 'intro'
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes)
	],
	exports: [
		RouterModule
	]
})

/**
 * (c) it.x informationssysteme gmbh, Alle Rechte vorbehalten.
 *
 * App Routing Module.
 * Provides application wide routes.
 */
export class AppRoutingModule
{}


// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/app-routing.module.ts